// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2b3Ki","left":"styles_left__m7nKN"};